import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import langResources from '../assets/lang';

import {
  constants as localStorageConstants,
  getFromLocalStorage,
} from './localStorage';

export const lng = getFromLocalStorage(localStorageConstants.language);

i18n.use(initReactI18next).init(
  {
    resources: langResources,
    fallbackLng: process.env.REACT_APP_DEFAULT_LANGUAGE || 'ar',
    debug: false,
    lng,

    // have a common namespace used around the full app
    ns: ['basic'],
    defaultNS: 'basic',

    keySeparator: true, // we use content as keys

    interpolation: {
      escapeValue: false,
    },
  } as any,
  () => {
    // if (!lng) {
    //   setInLocalStorage(
    //     localStorageConstants.language,
    //     process.env.REACT_APP_DEFAULT_LANGUAGE || 'ar'
    //   );
    // }
  },
);

window.document.body.dir = i18n.t('dir');
i18n.changeLanguage(lng ? lng : '');

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const _t = (key: string, rest?: any): any => {
  return i18n.t(key, { ...rest });
};

export default i18n;
